import React, { useState, useEffect, useContext } from 'react'
import {
  AppBar,
  ToggleButtonGroup,
  ToggleButton,
  Box,
  Tabs,
  Tab,
  Icon,
  Button,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import {
  UserMenu,
  Logout,
  LoadingIndicator,
  useTranslate,
  useLogout,
  useUserMenu,
  useNotify,
} from 'react-admin'
import { getUserPermissions } from 'src/services/getUserPermission'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { ProductNavigationActions } from 'src/components/uiElements/CRUD/ProductNavigationActions'
import { CheckCircle, ErrorOutline, Settings } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { LoadingButton } from '@mui/lab'
import { userServices } from 'src/services/auth/user/user.service'
import orderBy from 'lodash/orderBy';
import { LanguageSelector } from './LanguageSelector'
import { MyDevicesButton } from './MyDevices'
import betoIcon from '../../../assets/chatbot/beto.png';
import { ChatbotContext } from './ChatbotContext'
import { HasPermission } from 'src/helper/HasPermission'
import { ManageClients } from './ManageClients'
import { TimezoneSelector } from './TimezoneSelector'


const PasswordMenuItem = React.forwardRef(({ onClick, ...props }, ref) => {
  const translate = useTranslate()
  const { onClose } = useUserMenu()

  const handleClick = () => {
    onClose()
    onClick && onClick()
  }

  return (
    <MenuItem ref={ref} onClick={handleClick} {...props}>
      <ListItemIcon>
        <Settings />
      </ListItemIcon>
      <ListItemText>{translate('ra.action.change_password')}</ListItemText>
    </MenuItem>
  )
})

const ChatbotIcon = () =>{
  const {setShowFabChat, setChatPosition} = useContext(ChatbotContext);
  return(
    <img 
      src={betoIcon} 
      style={{marginRight:'15px', cursor:'pointer'}} alt="Icono" width={25} 
      onClick={()=>{
        setShowFabChat(true);
        const position = {
            x: /* window.innerWidth -  */50,
            y: /* window.innerHeight - */ 20,
        }
        localStorage.setItem("fabPosition", JSON.stringify(position));
        setChatPosition(position)
      }}
    />
  )
}

const NavigationTabs = ({ selectedModule, entity }) => {
  const translate = useTranslate()
  const [currentModule, setCurrentModule] = useState(selectedModule?.name)
  const [selectedTab, setSelectedTab] = useState(entity)

  useEffect(() => {
    if (!selectedModule && !entity) {
      setCurrentModule(null)
      setSelectedTab(null)
    }
  }, [selectedModule, entity])

  const LinkTab = (props) => {
    return (
      <Tab
        component={Link}
        icon={
          <ArrowForwardIosIcon fontSize='small' className={` ${props.selected !== true ? 'hidden' : ''} `} />
        }
        iconPosition='start'
        to={props.to}
        label={props.label}
        value={props.value}
        {...props}
      />
    )
  }

  const handleChange = (event, tab) => {
    setCurrentModule(selectedModule.name)
    setSelectedTab(tab)
  }

  // 1. Crear una nueva lista con traducciones
  const menuItemsWithTranslation = selectedModule?.permission
  .filter(item => item?.actions.find(action => action?.action === 'menu')) // Filtra los items que tienen la acción 'menu'
  .map(item => {
    return {
      ...item,
      translatedEntity: translate(`ra.entity.${item.entity}`).includes('.')
        ? item.entity
        : translate(`ra.entity.${item.entity}`)
    };
  });
  
  // 2. Ordenar la lista por la traducción en español
  const sortedMenuItems = orderBy(menuItemsWithTranslation, ['translatedEntity'], ['asc']);

  return (
    <Box sx={{ width: '100%' }} className='navigationTabsPanel'>
      {sortedMenuItems && (
        <Tabs
          value={currentModule === selectedModule?.name ? selectedTab : false}
          onChange={handleChange}
          variant='scrollable'
          scrollButtons='auto'
        >
          {sortedMenuItems.map((item) => {
            return (
              item.menu &&
              item?.actions.find((action) => action?.action === 'menu') && (
                <LinkTab
                  key={item.entity_id}
                  className='subMenuItem'
                  label={item.translatedEntity}
                  to={`/${item.entity}`}
                  value={item.entity}
                />
              )
            )
          })}
        </Tabs>
      )}
    </Box>
  )
}

const MyAppBar = ({ customTitle, ...props }) => {
  const translate = useTranslate()
  const location = useLocation()
  const logout = useLogout()
  const notify = useNotify()
  const [selectedModule, setSelectedModule] = useState()
  const [initialLoad, setInitialLoad] = useState(true)
  const [passwordData, setPasswordData] = useState({})
  const [openPasswordModal, setOpenPasswordModal] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [loadingPassword, setLoadingPassword] = useState(false)
  const urlArray = location.pathname.split('/')
  const permission = getUserPermissions()
  const clients = JSON.parse(localStorage.getItem('clients')) ?? []
  const user = JSON.parse(localStorage.getItem('user'))
  const clientName = clients?.find(cli=>cli.client_id === user?.client_id)?.name
  const [confirmChangeClient, setConfirmChangeClient] = useState(false)

  useEffect(()=>{
    if(confirmChangeClient){
      setSelectedModule(null)
    }
  },[confirmChangeClient])

  if (!permission?.hasOwnProperty('modules')) {
    logout()
    return
  }

  const modules = permission.modules
  let module = null
  let entity = null
  let id = null
  let state = null

  if (urlArray.length > 1) {
    entity = urlArray[1]
    if (urlArray.length > 2) {
      if (!isNaN(urlArray[2])) {
        id = urlArray[2]
        state = urlArray.includes('show') ? translate('ra.action.show') : translate('ra.action.edit')
      } else {
        state = entity === 'payment' ? translate('ra.action.generate') : translate('ra.action.create')
      }
    }
  }

  if (entity) {
    const selectedModuleAux = modules.find((moduleAux) =>
      moduleAux.permission.find((entityAux) => entityAux.entity === entity)
    )
    module = selectedModuleAux?.name

    if (initialLoad && !selectedModule) {
      setSelectedModule(selectedModuleAux)
      setInitialLoad(false)
    }
  }

  const allMenusAreFalse = (permissions) => {
    return permissions.permission.every((perm) => !perm.menu)
  }

  const hasMenuPermission = (permissions) => {
    // si tiene la propiedad menu en true
    let permissions_with_menu_in_true = permissions.permission.filter((permission) => permission.menu)
    // y ademas alguno de los objetos que tenia la propidad en true tiene la "action" : "menu" devolvera true
    return permissions_with_menu_in_true.some((perm) =>
      perm.actions.some((action) => action.action === 'menu')
    )
  }

  const handleOpenClosePasswordModal = () => {
    setPasswordData({})
    setPasswordError({})
    setOpenPasswordModal(!openPasswordModal)
  }

  const handleChangePasswordField = (value, field) => {
    setPasswordData((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const handleConfirmPassword = () => {
    let errors = {}
    const form = {}

    if (passwordData.currentPassword) {
      form['current_password'] = passwordData.currentPassword
    } else {
      errors['currentPassword'] = true
    }

    if (!passwordData.confirmNewPassword) {
      errors['confirmNewPassword'] = true
    }

    if (passwordData.newPassword) {
      form['password'] = passwordData.newPassword

      if (passwordData.confirmNewPassword && passwordData.newPassword !== passwordData.confirmNewPassword) {
        errors['confirmNewPassword'] = 'invalid_password'
      }
    } else {
      errors['newPassword'] = true
    }

    setPasswordError(errors)

    if (Object.keys(errors).length === 0) {
      setLoadingPassword(true)
      const user = JSON.parse(localStorage.getItem('user'))
      userServices
        .changePassword(user.user_id, form)
        .then((reponse) => {
          setOpenPasswordModal(false)
          notify('ra.notification.change_password_success', { type: 'success' })
        })
        .catch((error) => {
          notify('ra.notification.change_password_error', { type: 'error' })
        })
        .finally(() => {
          setLoadingPassword(false)
        })
    }
  }

  return (
    <>
      <AppBar position='relative' className='headerAppBar'>
        <Box flex={1} display='flex' justifyContent='space-between' alignItems='center'>
          <Box display='flex'>
            <Button
              color='inherit'
              component={Link}
              startIcon={<Icon>dashboard</Icon>}
              to='/'
              value='/'
              className='headerMainButton'
              onClick={() => setSelectedModule(null)}
            >
              {`${clientName} B2`}
            </Button>

            <ToggleButtonGroup
              value={selectedModule?.name}
              exclusive
              onChange={(e, module) =>
                setSelectedModule(module ? modules.find((elem) => elem.name === module) : null)
              }
              aria-label='text alignment'
              className='moduleMenuToggle'
            >
              {modules.map((module, i) => {
                if (!allMenusAreFalse(module)) {
                  if (hasMenuPermission(module)) {
                    let startIcon
                    if (module.process) {
                      startIcon = module.process.find((item) => item.name === 'startIcon')?.text
                    }
                    return (
                      <ToggleButton key={i} value={module.name} aria-label='aligned'>
                        {startIcon ? <Icon>{startIcon}</Icon> : null}
                        <div>
                          {translate(`ra.modules.${module.name}`).includes('.')
                            ? module.name
                            : translate(`ra.modules.${module.name}`)}
                        </div>
                        <Icon>{selectedModule?.name === module.name ? 'expand_less' : 'expand_more'}</Icon>
                      </ToggleButton>
                    )
                  }
                }
                return null
              })}
            </ToggleButtonGroup>
          </Box>
          <Box display='flex' alignItems='center'>
            <LoadingIndicator className='loading-indicator' />
            <UserMenu className='appBarUser'>
              {clients.length > 1 &&
                <>
                  <ManageClients 
                    confirmChangeClient={confirmChangeClient} 
                    setConfirmChangeClient={setConfirmChangeClient}
                  />
                  <hr />
                </>
              }
              <LanguageSelector />
              <TimezoneSelector />
              <MyDevicesButton/>
              <hr />
              <Logout />
              <PasswordMenuItem onClick={handleOpenClosePasswordModal} />
            </UserMenu>
            <HasPermission resource={'application'} permission='chatbot'>
              <ChatbotIcon/>
            </HasPermission>
          </Box>
        </Box>
      </AppBar>
      <NavigationTabs selectedModule={selectedModule} entity={entity} />
      <ProductNavigationActions
        module={module}
        entity={entity}
        id={id}
        state={state}
        customTitle={customTitle}
      />

      <Dialog open={openPasswordModal} maxWidth='xs' fullWidth>
        <DialogTitle>{translate('ra.message.change_password_title')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <EditInputsWrap md={12} lg={12} className='small' label={translate('ra.field.current_password')}>
              <TextField
                size='small'
                fullWidth
                type='password'
                error={passwordError.currentPassword}
                value={passwordData.currentPassword}
                onChange={(e) => handleChangePasswordField(e.target.value, 'currentPassword')}
              />
            </EditInputsWrap>
            <EditInputsWrap md={12} lg={12} className='small' label={translate('ra.field.new_password')}>
              <TextField
                size='small'
                fullWidth
                type='password'
                error={passwordError.newPassword}
                value={passwordData.newPassword}
                onChange={(e) => handleChangePasswordField(e.target.value, 'newPassword')}
              />
            </EditInputsWrap>
            <EditInputsWrap
              md={12}
              lg={12}
              className='small'
              label={translate('ra.field.confirm_new_password')}
            >
              <TextField
                size='small'
                fullWidth
                type='password'
                error={Boolean(passwordError.confirmNewPassword)}
                helperText={
                  typeof passwordError.confirmNewPassword === 'string'
                    ? translate(`ra.message.${passwordError.confirmNewPassword}`)
                    : ''
                }
                value={passwordData.confirmNewPassword}
                onChange={(e) => handleChangePasswordField(e.target.value, 'confirmNewPassword')}
              />
            </EditInputsWrap>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={loadingPassword}
            onClick={handleOpenClosePasswordModal}
            startIcon={<ErrorOutline />}
          >
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            loading={loadingPassword}
            onClick={handleConfirmPassword}
            className='ra-confirm'
            startIcon={<CheckCircle />}
          >
            {translate('ra.action.to_confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MyAppBar
